import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  message,
  Select,
} from "antd";
import React, { useEffect, useState, useRef, useContext } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import UserServices from "../../services/UserServices";
import { translate } from "../../locale";
import DashServices from "../../services/DashServices";
import { AdminContext } from "../../providers/AdminContext";

const InviteContact = ({ data, visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [values, setValues] = useState({
    subscription_id: "",
    email: "",
  });
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();
  const [subscriptions, setSubscriptions] = useState([]);
  const { user } = useContext(AdminContext);

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
        email: "El email no es válido",
      },
    })
  );

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true && data?.emails) {
        setValues((v) => ({ ...v, email: data.emails }));

        getContactSubscriptions();
      } else if (visible === true && data?.emails === "") {
        getProfessionalSubscriptions();
      }
    }
  }, [visible, data]);

  const disabled = () => !simpleValidator.current.allValid();

  const getContactSubscriptions = async () => {
    try {
      setLoading(true);
      const response = await DashServices.getAvailableSubscriptions(
        data.emails,
        data.role
      );
      if (response.status >= 200 && response.status < 300) {
        setSubscriptions(
          response.data.available_subscriptions.map((i) => ({
            value: i.id,
            label: i.name,
          }))
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getProfessionalSubscriptions = async () => {
    try {
      setLoading(true);
      const response = await DashServices.getSubscriptions();
      if (response.status >= 200 && response.status < 300) {
        console.log("getProfessionalSubscriptions", data.user);
        setSubscriptions(
          response.data.subscriptions.map((i) => ({
            value: i.id,
            label: i.name,
          }))
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onFinish = async () => {
    console.log("onFinish:", values);
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("El email ingresado no es válido");
      return;
    }
    try {
      const _data = {
        email: values.email,
        subscription_id: values.subscription_id,
        type: "email",
        rol: data.role,
        app: "eira",
      };
      const res = await UserServices.sendContactInvitation(_data);
      if (res) {
        if (res.status === 200) {
          message.success("La invitación se envió exitosamente.");
          resetForm();
          if (onComplete) {
            onComplete();
          }
        } else {
          setError("No pudimos enviar la invitación.");
        }
        setLoading(false);
      } else {
        setError("Log in error");
      }
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const resetForm = () => {
    setValues({
      email: "",
    });
    setError("");
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <Modal
      open={active}
      title={translate("Enviar solicitud")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      {/* <Row align="center" gutter={16}>
        <Col>Servicio aun no disponible.</Col>
      </Row> */}

      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        className="w-full"
      >
        <Form.Item>
          <Input
            placeholder="E-mail"
            className="border-custom_primary"
            name="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          {simpleValidator.current.message(
            "email",
            values.email,
            "required|email"
          )}
        </Form.Item>
        <Form.Item>
          <Select
            defaultValue={""}
            name="subscription_id"
            onChange={(value) => {
              setValues((v) => ({ ...v, subscription_id: value }));
            }}
            value={values.subscription_id}
          >
            <Select.Option value="">Seleccione suscripción</Select.Option>
            {subscriptions.map((item, key) => (
              <Select.Option key={key} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
          {simpleValidator.current.message(
            "subscription_id",
            values.subscription_id,
            "required"
          )}
        </Form.Item>
        <Form.Item>
          <Row align="end" gutter={16}>
            <Col>
              <Button key="back" onClick={handleCancel}>
                Cancelar
              </Button>
            </Col>
            <Col>
              <Button
                disabled={disabled()}
                htmlType="submit"
                type="primary"
                className="bg-custom_primary"
              >
                {loading ? (
                  <Spin
                    indicator={<LoadingOutlined style={{ color: "#666666" }} />}
                  />
                ) : (
                  "Enviar"
                )}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default InviteContact;
